import { useEffect, type RefObject } from 'react';

/**
 * Publishes the shell header's height as `--app-header-h` on <html>. On phones the page itself scrolls and
 * the header sticks to the top of it, so anything else pinned while scrolling (the quiz timer) has to stop
 * below it rather than slide under it. The header's height varies (banner, wrapping, font size), so it is
 * measured, not hard-coded.
 */
export function useStickyHeaderHeight(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const root = document.documentElement;
    const publish = () => root.style.setProperty('--app-header-h', `${Math.round(el.getBoundingClientRect().height)}px`);
    publish();
    const ro = new ResizeObserver(publish);
    ro.observe(el);
    return () => { ro.disconnect(); root.style.removeProperty('--app-header-h'); };
  }, [ref]);
}
